import request from '@/config/axios'

export interface MerchantAccountOption {
  id: number
  username: string
  realName?: string
  merchantId?: number
  shopId?: number
}

/** 商家登录账号精简列表，可按商家主体/店铺过滤 */
export const getMerchantAccountSimpleList = (params?: {
  merchantId?: number
  shopId?: number
}) =>
  request.get<MerchantAccountOption[]>({
    url: '/merchant/account/simple-list',
    params
  })
